import { Component, Input, OnChanges } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { StatusDistribution } from '../../../models/analytics.model';

@Component({
    selector: 'app-analytics-status-chart',
    templateUrl: './analytics-status-chart.component.html',
    styleUrls: ['./analytics-status-chart.component.scss'],
})
export class AnalyticsStatusChartComponent implements OnChanges {
    @Input() data: StatusDistribution[] = [];
    @Input() total = 0;

    chartData: ChartConfiguration<'bar'>['data'] = { labels: [], datasets: [] };

    chartOptions: ChartConfiguration<'bar'>['options'] = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
        },
        scales: {
            x: {
                grid: { display: false },
            },
            y: {
                beginAtZero: true,
                ticks: { precision: 0 },
            },
        },
    };

    ngOnChanges(): void {
        if (!this.data || this.data.length === 0) return;

        this.chartData = {
            labels: this.data.map((s) => s.name),
            datasets: [
                {
                    data: this.data.map((s) => s.count),
                    backgroundColor: this.data.map((s) => s.color),
                    borderRadius: 4,
                },
            ],
        };
    }
}
